import { gql } from "@apollo/client";

export const GET_URL_CLASSIFICATION = gql`
  query UrlClassification($url: String!, $publisher: PublisherEnum!) {
    urlClassification(url: $url, publisher: $publisher) {
      id
      pageUrl
      # insertionTime
      lastUpdateTime
      results {
        precision_iab_v3
        cat_brandsafety
        illuma_sent
        illuma_emotion
        illuma_ents_FAC
        illuma_ents_ORG
        illuma_ents_GPE
        illuma_ents_LOC
        illuma_ents_PRODUCT
        illuma_ents_NORP
        # catEntsLaw
        # catEntsNorp
        illuma_ents_DATE
        # catEntsTime
        illuma_ents_EVENT
        # catEntsMoney
        illuma_ents_PERSON
        illuma_ents_LAW
        illuma_ents_LANGUAGE
        illuma_ents_MONEY
        # catEntsProduct
        # catEntsPercent
        # catEntsOrdinal
        # catEntsLanguage
        # catEntsQuantity
        # catEntsCardinal
        illuma_ents_WORK_OF_ART
      }
    }
  }
`;

export const GET_URL_LIST = gql`
  query UrlList(
    $publisher: PublisherEnum!
    $first: Int!
    $offset: Int!
    $search: String
    $category: String
    $range: RangeEnum
    $startDate: Date
    $endDate: Date
  ) {
    urlList(
      publisher: $publisher
      first: $first
      offset: $offset
      search: $search
      category: $category
      range: $range
      startDate: $startDate
      endDate: $endDate
    ) {
      hasNextPage
      urlList {
        id
        pageUrl
        insertionTime
        lastUpdateTime
      }
    }
  }
`;

export const GET_OPTIMUS_DATA_REPORT_STORE = gql`
  query ReportStoreCampaign(
    $dsp: String!,
    $lineItemIds: [String!]!,
    $lineType: LineTypeChoicesEnum!,
    $startDate: Date!,
    $endDate: Date!,
    $costColumn: String!
  ) {
    reportStoreCampaign(
      dsp: $dsp,
      lineItemIds: $lineItemIds,
      lineType: $lineType,
      startDate: $startDate,
      endDate: $endDate,
      costColumn: $costColumn
    ) {
      campaign_data {
        date
        mediaCost
        campaignId
        impressions
        clicks
        vcr
        cpv
        cpa
        cpc
        ctr
        cpm
        viewability
      }
    }
  }
`;

export const GET_PREDICTED_URLS = gql`
  query PredictedUrlsList(
      $publisher: PublisherEnum!, 
      $url: String!, 
      $matchThreshold: Float! 
    ) {
      predictedUrlsList(
        publisher: $publisher, 
        url: $url, 
        matchThreshold: $matchThreshold
      ) {
          predictedFrom
          urls
      }
    }
`;

export const GET_PUBLISHER_DOMAINS = gql`
  query PublisherDomains($isStaff: Boolean, $publisher: PublisherEnum) {
    publisherDomains(isStaff: $isStaff, publisher: $publisher) {
      id
      domain
      publisher
    }
  }
`

export const GET_BRAND_SAFETY_INSIGHTS = gql`
  query BrandSafetyInsights($breakdownType: BreakdownTypeEnum!, $brand: BrandChoicesEnum!, $pageTypes:[String!], $advertiserIds:[String!], $campaignIds: [String!], $adGroupIds: [String!], $startDate: Date!, $endDate: Date!) {
    brandSafetyInsights(breakdownType: $breakdownType, brand: $brand, pageTypes: $pageTypes, advertiserIds: $advertiserIds, campaignIds: $campaignIds, adGroupIds: $adGroupIds, startDate: $startDate, endDate: $endDate) {
      brandUnsafeRate
      unsafeImpressions
      advertiserDistribution {
        advertiserId
        totalImpressions
        brandUnsafeRate
      }
      topFlaggedUnsafeTopic
      topSensitiveTopics {
        sensitiveTopic
        totalUnsafeImpressions
        unsafeImpressionShare
      }
      topTopics {
        topic
        impressionShare
      }
      
    }
  }
`

export const GET_BRAND_SAFETY_INSIGHTS_BY_DATE = gql`
  query BrandSafetyInsightsDistributionByDate($breakdownType: BreakdownTypeEnum!, $brand: BrandChoicesEnum!, $pageTypes:[String!], $advertiserIds:[String!], $campaignIds: [String!], $adGroupIds: [String!], $startDate: Date!, $endDate: Date!) {
    brandSafetyInsightsDistributionByDate(breakdownType: $breakdownType, brand: $brand, pageTypes:$pageTypes, advertiserIds: $advertiserIds, campaignIds: $campaignIds, adGroupIds: $adGroupIds, startDate: $startDate, endDate: $endDate) {
      insightDistributionByDate {
        aggregationDate
        allImpressions
        brandUnsafeRate
      }
    }
  }
`

export const GET_CAMPAIGN_IDS = gql`
  query GetTacticIds($breakdownType: BreakdownTypeEnum!, $brand: BrandChoicesEnum!, $pageTypes:[String!],  $advertiserIds:[String!], $campaignIds: [String!], $adGroupIds: [String!], $startDate: Date!, $endDate: Date!, $idType: TacticIdTypeEnum!) {
    getTacticIds(breakdownType: $breakdownType, brand: $brand, pageTypes:$pageTypes, advertiserIds: $advertiserIds, campaignIds: $campaignIds, adGroupIds: $adGroupIds, startDate: $startDate, endDate: $endDate, idType: $idType) {
      ids
    }
  }
`